import classNames from 'classnames'
import React from 'react'
import { Grid } from '../Grid'
import { Image, ImageProps } from '../Image'
import { SignupFormBox, SignupFormBoxProps } from './SignupFormBox'

export interface SignupFormBlockProps extends SignupFormBoxProps {
  additionalClassName?: string
  image?: ImageProps
  useNewDesign: boolean
}

export const SignupFormBlock = ({
  additionalClassName,
  image,
  ...signupFormBoxProps
}: SignupFormBlockProps): JSX.Element => {
  const signupFormGridClasses = image
    ? classNames(
        'col-span-full -mx-30',
        'tb:col-start-3 tb:col-span-2 tb:mt-75 tb:-ml-90 tb:mr-30',
        'sm:col-start-4 sm:col-span-3 sm:-ml-60 sm:mr-90',
        'md:ml-0 md:mr-30',
        'lg:col-start-5 lg:col-span-3',
        'xl:col-start-6 xl:col-span-4',
        'xxl:col-start-8 xxl:col-span-4'
      )
    : classNames(
        'col-span-full -mx-30',
        'tb:col-start-2 tb:col-span-2 tb:-mx-60',
        'sm:col-start-2 sm:col-span-4 sm:mx-60',
        'lg:col-start-3 lg:col-span-4',
        'xl:col-start-4 xl:col-span-4 xl:mx-30',
        'xxl:col-start-6 xl:col-span-4'
      )

  return (
    <Grid additionalClassName={additionalClassName}>
      {image && (
        <div
          className={classNames(
            'hidden',
            'tb:block tb:col-start-1 tb:col-span-2 tb:ml-30 tb:-mr-30',
            'sm:col-start-1 sm:col-span-3 sm:ml-90 sm:-mr-60',
            'md:ml-30 md:-mr-60',
            'lg:col-start-2 lg:col-span-3',
            'xl:col-start-2 xl:col-span-4',
            'xxl:col-start-4 xxl:col-span-4'
          )}
        >
          <Image
            {...image}
            applyLqip
            imgClassName="rounded w-full"
            loading="lazy"
            caption=""
            copyright=""
          />
        </div>
      )}

      <div className={signupFormGridClasses}>
        <SignupFormBox {...signupFormBoxProps} />
      </div>
    </Grid>
  )
}
